module.exports = __webpack_public_path__ + "img/feat_safe.6c7948b4.png";